import { SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

export class HtmlSanitizerUtil {
  private static readonly DEFAULT_ALLOWED_TAGS = ['b', 'br', 'strong', 'i', 'em'];

  static sanitizeHtmlContent(content: string, sanitizer: DomSanitizer, options?: string[]): SafeHtml {
    if (!content) {
      return '';
    }

    const allowedTags = options || this.DEFAULT_ALLOWED_TAGS;

    if (allowedTags.length > 0) {
      const allowedTagsPattern = allowedTags.join('|');
      const regex = new RegExp(`<(?!\\/?(?:${allowedTagsPattern})\\b)[^>]*>`, 'gi');
      content = content.replace(regex, '');
    } else {
      content = content.replace(/<[^>]*>/g, '');
    }

    return sanitizer.sanitize(SecurityContext.HTML, content) || '';
  }

  static sanitizeErrorMessage(errorMessage: string, sanitizer: DomSanitizer): SafeHtml {
    return this.sanitizeHtmlContent(errorMessage, sanitizer);
  }
}
